import React from 'react';

import Icon from 'components/generic/Icon.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './NetworkSpeedChecker.module.scss';

const SuccessfulText = () => {
  const { t } = useTranslation();

  return (
    <span data-bem="SuccessfulText" className={CN.success}>
      <Icon variant="on" width="xl" />
      {t('staffAndBusiness.userNetwork.hardwareInformation.meetsRequirements')}
    </span>
  );
};

export default SuccessfulText;
